import React, { useEffect } from "react";
import Orders from "../Myorders/Orders";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";

const MyOrdersM = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <Orders />
      <Footer />
    </>
  );
};

export default MyOrdersM;
